/* eslint-disable */
import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { logOutUser, generateToastError } from '../../../utils';
import { queryKeys } from '../queryKeys';

const httpStatuses = { unauthorized: 401, error: 500 };
const userToken = JSON.parse(localStorage.getItem('user'))?.token

export const useQueryGetTodayQuote = (payload, toast) => {
  const queryKey = [queryKeys.getTodayQuote, payload];
  const queryFn = () => axios.get(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/get-today-quote`, {
    headers: { Authorization: `Bearer ${userToken}` },
  });

  return useQuery(queryKey, queryFn, {
    enabled: true,
    retry: 0,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60,
    select: (res) => res?.data?.data?.quote ?? null,
    onError: (e) => {
      generateToastError(toast, e);
    },
  });
};

export const useQueryGetAllQuotes = (payload, toast) => {
  const queryKey = [queryKeys.getAllQuotes, payload];
  const queryFn = () => axios.get(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/get-all-quotes`, {
    headers: { Authorization: `Bearer ${userToken}` },
  });

  return useQuery(queryKey, queryFn, {
    enabled: true,
    retry: 0,
    refetchOnWindowFocus: false,
    staleTime: 0,
    select: (res) => res?.data?.data ?? [],
    onError: (e) => {
      generateToastError(toast, e);
    },
  });
};

export const useMutationAddQuote = (toast) => {
  const queryClient = useQueryClient();
  
  return useMutation(
    [queryKeys.addQuote], 
    (payload) => axios.post(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/add-quote`, payload, {
      headers: { Authorization: `Bearer ${userToken}` },
    }), 
    {
      onSuccess: (success) => {
        toast.success(`${success.data.message}`, {
          duration: 10000,
        });
        queryClient.invalidateQueries({ queryKey: [queryKeys.getAllQuotes] });
      },
      onError: (error) => {
        try {
          if (error?.response?.status === httpStatuses.unauthorized) {
            logOutUser();
            return;
          }
          generateToastError(toast, error);
        } catch (e) {
          toast.error('The Error ', e);
        }
      },
    }
  );
};

export const useMutationUpdateQuoteByDate = (toast) => {
  const queryClient = useQueryClient();
  
  return useMutation(
    [queryKeys.updateQuote], 
    (payload) => axios.put(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/update-quote`, payload, {
      headers: { Authorization: `Bearer ${userToken}` },
    }), 
    {
      onSuccess: (success) => {
        toast.success(`${success.data.message}`, {
          duration: 3000,
        });
        queryClient.invalidateQueries({ queryKey: [queryKeys.getAllQuotes] });
      },
      onError: (error) => {
        try {
          if (error?.response?.status === httpStatuses.unauthorized) {
            logOutUser();
            return;
          }
          generateToastError(toast, error);
        } catch (e) {
          toast.error('The Error ', e);
        }
      },
    }
  );
};

export const useMutationUpdateQuoteById = (toast) => {
  const queryClient = useQueryClient();
  
  return useMutation(
    [queryKeys.updateQuote], 
    ({ id, quote }) => axios.put(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/${id}`, { quote }, {
      headers: { Authorization: `Bearer ${userToken}` },
    }), 
    {
      onSuccess: (success) => {
        toast.success(`${success.data.message}`, {
          duration: 3000,
        });
        queryClient.invalidateQueries({ queryKey: [queryKeys.getAllQuotes] });
      },
      onError: (error) => {
        try {
          if (error?.response?.status === httpStatuses.unauthorized) {
            logOutUser();
            return;
          }
          generateToastError(toast, error);
        } catch (e) {
          toast.error('The Error ', e);
        }
      },
    }
  );
};

export const useMutationDeleteQuote = (toast) => {
  const queryClient = useQueryClient();
  
  return useMutation(
    [queryKeys.deleteQuote], 
    (id) => axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/delete-quote/${id}`, {
      headers: { Authorization: `Bearer ${userToken}` },
    }), 
    {
      onSuccess: (success) => {
        toast.success(`${success.data.message}`, {
          duration: 3000,
        });
        queryClient.invalidateQueries({ queryKey: [queryKeys.getAllQuotes] });
      },
      onError: (error) => {
        try {
          if (error?.response?.status === httpStatuses.unauthorized) {
            logOutUser();
            return;
          }
          generateToastError(toast, error);
        } catch (e) {
          toast.error('The Error ', e);
        }
      },
    }
  );
};

export const useMutationBulkUploadQuotes = (toast) => {
  const queryClient = useQueryClient();
  
  return useMutation(
    [queryKeys.bulkUploadQuotes],
    async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return axios.post(`${process.env.REACT_APP_SERVER_URL}/api/daily-quotes/bulk-upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userToken}`,
        },
      });
    },
    {
      onSuccess: (success) => {
        toast.success(`${success.data.message}`, {
          duration: 10000,
        });
        queryClient.invalidateQueries({ queryKey: [queryKeys.getAllQuotes] });
      },
      onError: (error) => {
        try {
          if (error?.response?.status === httpStatuses.unauthorized) {
            logOutUser();
            return;
          }
          generateToastError(toast, error);
        } catch (e) {
          toast.error('The Error ', e);
        }
      },
    }
  );
};


